module.exports = __webpack_public_path__ + "img/s2.b3064ea3.png";